// src/pages/container_rental/components/InitialMonthsField.tsx
//
// Numeric input + a row of "common value" chips. Picked over Autocomplete
// freeSolo because react-hook-form's controlled mode is simpler with a plain
// TextField and the chip row makes the common values explicitly tappable on
// mobile (target users are site managers).

import { Box, Chip, TextField, Typography } from "@mui/material";

interface InitialMonthsFieldProps {
  value: number | "";
  onChange: (v: number | "") => void;
  error?: boolean;
  helperText?: string;
}

const COMMON_MONTHS = [1, 2, 3, 6];

export default function InitialMonthsField({
  value,
  onChange,
  error,
  helperText,
}: InitialMonthsFieldProps) {
  return (
    <Box>
      <TextField
        label="초기 선결제 (개월)"
        type="number"
        value={value === "" || value == null ? "" : value}
        onChange={(e) => {
          const v = e.target.value;
          onChange(v === "" ? "" : Math.max(1, Math.floor(Number(v))));
        }}
        inputProps={{ min: 1 }}
        fullWidth
        error={error}
        helperText={helperText}
      />
      <Box sx={{ mt: 0.75, display: "flex", alignItems: "center", gap: 0.75, flexWrap: "wrap" }}>
        <Typography variant="caption" color="text.secondary">자주 쓰는 값:</Typography>
        {COMMON_MONTHS.map((m) => (
          <Chip
            key={m}
            label={`${m}개월`}
            size="small"
            variant={value === m ? "filled" : "outlined"}
            color={value === m ? "primary" : "default"}
            onClick={() => onChange(m)}
            clickable
          />
        ))}
      </Box>
    </Box>
  );
}
